// ?? Essa é a rota original de cadastro "/cadastro"

export const signupNav = "/not-found";
